var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"page-header"},[_c(_setup.Action,{attrs:{"onClick":_setup.goBack,"variant":"danger","rounded":"full"}},[_c(_setup.ArrowLeftIcon)],1),_c('h1',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }